export default __webpack_public_path__ + "static/media/330_business01-en-mobile.2d747614.png";